import React, { useContext } from "react";
import { AppContext } from "../../../../appContext";
import { ISideMenuRouteProps } from "./ISideMenuRouteProps";
import { PopupWrapper } from "../../../../components/styled/BasicBlocks";
import { SideMenuCommonHeader } from "./SideMenuCommon";
import "./SideMenuFaq.css";

export const SideMenuFaq = ({ onClose }: ISideMenuRouteProps) => {
    const { translate } = useContext(AppContext);
    
    const renderSection = (title: string, items: Array<{question: string, answer: string}>) => (
        <div className="SideMenuFaq_section">
            <h2 className="SideMenuFaq_section_title">{title}</h2>
            {items.map((item, index) => (
                <div key={index} className="SideMenuFaq_item">
                    <h3 className="SideMenuFaq_question">{item.question}</h3>
                    <p className="SideMenuFaq_answer">{item.answer}</p>
                </div>
            ))}
        </div>
    );

    return <PopupWrapper className="SideMenuFaq">
        <SideMenuCommonHeader text={translate('sideMenu_faq')} onClose={onClose}>
        </SideMenuCommonHeader>
        <div className="SideMenuFaq_content">
            {renderSection(translate('faq_general_title'), [
                {
                    question: translate('faq_general_q1'),
                    answer: translate('faq_general_a1')
                },
                {
                    question: translate('faq_general_q2'),
                    answer: translate('faq_general_a2')
                }
            ])}

            {renderSection(translate('faq_clients_title'), [
                {
                    question: translate('faq_clients_q1'),
                    answer: translate('faq_clients_a1')
                },
                {
                    question: translate('faq_clients_q2'),
                    answer: translate('faq_clients_a2')
                }
            ])}

            {renderSection(translate('faq_sessions_title'), [
                {
                    question: translate('faq_sessions_q1'),
                    answer: translate('faq_sessions_a1')
                },
                {
                    question: translate('faq_sessions_q2'),
                    answer: translate('faq_sessions_a2')
                },
                {
                    question: translate('faq_sessions_q3'),
                    answer: translate('faq_sessions_a3')
                }
            ])}

            {renderSection(translate('faq_analysis_title'), [
                {
                    question: translate('faq_analysis_q1'),
                    answer: translate('faq_analysis_a1')
                },
                {
                    question: translate('faq_analysis_q2'),
                    answer: translate('faq_analysis_a2')
                }
            ])}

            {renderSection(translate('faq_support_title'), [
                {
                    question: translate('faq_support_q1'),
                    answer: translate('faq_support_a1')
                },
                {
                    question: translate('faq_support_q2'),
                    answer: translate('faq_support_a2')
                },
                {
                    question: translate('faq_support_q3'),
                    answer: translate('faq_support_a3')
                }
            ])}
        </div>
    </PopupWrapper>
}